/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface TAccount {
  /** @format uuid */
  uuid: string;
  type: TAccountType;
  name: string;
  description?: string;
  currency: TCurrency;
  icon: TIcon;
  color: TColor;
  balance?: number;
  limitation?: number;
  /**
   * @format yyyy-MM-dd
   * @example "2020-03-15"
   */
  deadlineAt?: string;
}

export enum TAccountType {
  Debt = "debt",
  ExpenseCategory = "expense-category",
  Goal = "goal",
  IncomeSource = "income-source",
  Saving = "saving",
}

export enum TColor {
  ValueE22C2C = "#E22C2C",
  ValueF56514 = "#F56514",
  ValueF58E14 = "#F58E14",
  ValueFFB800 = "#FFB800",
  ValueABD15B = "#ABD15B",
  Value9BB437 = "#9BB437",
  Value7DB437 = "#7DB437",
  Value2686DF = "#2686DF",
  Value4899B2 = "#4899B2",
  Value6EAEEA = "#6EAEEA",
  Value6E89EA = "#6E89EA",
  Value4869DC = "#4869DC",
  Value8948DC = "#8948DC",
  ValueC762D8 = "#C762D8",
  ValueE17DB9 = "#E17DB9",
  Value333333 = "#333333",
}

export enum TCountry {
  RUS = "RUS",
}

export enum TCurrency {
  EUR = "EUR",
  RUB = "RUB",
  USD = "USD",
}

export interface TDevice {
  /** @format uuid */
  uuid: string;
  externalId: string;
}

export enum TFeature {
  Value68E71955A0D34F628F1595Dd3203A112 = "68e71955-a0d3-4f62-8f15-95dd3203a112",
  Aaafc749879240E29EbcE047Aa2Cfd3D = "aaafc749-8792-40e2-9ebc-e047aa2cfd3d",
  Value6219A1C9D1894B5C92C943Bfc7D3A44C = "6219a1c9-d189-4b5c-92c9-43bfc7d3a44c",
  Value7A3915E4Ee0647228Df237999Bddb225 = "7a3915e4-ee06-4722-8df2-37999bddb225",
}

export enum TIcon {
  Advertisement = "advertisement",
  Bag = "bag",
  BarChart = "bar-chart",
  Basket = "basket",
  Bitcoin = "bitcoin",
  Bone = "bone",
  Book = "book",
  Briefcase = "briefcase",
  Brightness = "brightness",
  Brush = "brush",
  Calendar = "calendar",
  Cd = "cd",
  Coffee = "coffee",
  Comment = "comment",
  CreditCard = "credit-card",
  Cross = "cross",
  Cup = "cup",
  Cursor = "cursor",
  Delivery = "delivery",
  Gears = "gears",
  Gift = "gift",
  Globe = "globe",
  Heart = "heart",
  Home = "home",
  Horse = "horse",
  IceCream = "ice-cream",
  Laptop = "laptop",
  LightBulb = "light-bulb",
  Marker = "marker",
  Mobile = "mobile",
  MusicNote = "music-note",
  Phone = "phone",
  Pocket = "pocket",
  Rocket = "rocket",
  Shield = "shield",
  Wallet = "wallet",
  Watch = "watch",
  World = "world",
  Akbars = "akbars",
  Alfabank = "alfabank",
  Atb = "atb",
  CitiBank = "citi-bank",
  Domrf = "domrf",
  Gazprom = "gazprom",
  HomeCredit = "home-credit",
  Mkb = "mkb",
  Mts = "mts",
  Otkritie = "otkritie",
  Otp = "otp",
  Paypal = "paypal",
  PochtaBank = "pochta-bank",
  Psbank = "psbank",
  Qiwi = "qiwi",
  Raiffeisenbank = "raiffeisenbank",
  Rnkb = "rnkb",
  Rosbank = "rosbank",
  RosgosstrakhBank = "rosgosstrakh-bank",
  RusskiyStandart = "russkiy-standart",
  Sberbank = "sberbank",
  Skb = "skb",
  Sovcombank = "sovcombank",
  Tinkoff = "tinkoff",
  Tochka = "tochka",
  Ubrd = "ubrd",
  Unikredit = "unikredit",
  Uralsib = "uralsib",
  Vostochniy = "vostochniy",
  Vtb = "vtb",
  Yoomoney = "yoomoney",
}

export enum TLanguage {
  Ru = "ru",
}

export enum TPlatform {
  Ios = "ios",
  Android = "android",
  Web = "web",
}

/** @example {"USD":74,"RUB":1,"EUR":82} */
export type TRate = Record<string, string>;

export enum TTimeZone {
  AsiaVladivostok = "Asia/Vladivostok",
  UTC = "UTC",
}

export interface TTransaction {
  /** @format uuid */
  uuid: string;
  operationName: string;
  leftType: TAccountType;
  /** @format uuid */
  leftUuid: string;
  leftCurrency: TCurrency;
  rightType: TAccountType;
  /** @format uuid */
  rightUuid: string;
  rightCurrency: TCurrency;
  leftAmount: number;
  rate: number;
  rightAmount: number;
  /**
   * @format yyyy-MM-dd HH:mm
   * @example "2020-03-15 11:20"
   */
  processedAt: string;
  description?: string;
}

export interface TUser {
  /** @format uuid */
  uuid: string;
  currency: TCurrency;
  country: TCountry;
  language: TLanguage;
  login: string;
  password?: string;
  timeZone?: TTimeZone;
  phoneNumber?: string;
  email?: string;
  emailVerified?: boolean;
  synced?: boolean;
  randomLogin?: boolean;
  randomPassword?: boolean;
  pro?: boolean;
  features?: string[];
}

export interface TAppHttpApiSecurityControllerLoginPayload {
  login: string;
  password: string;
}

export interface TAppHttpApiSecurityControllerLoginData {
  /** @format email */
  token: string;
  refreshToken: string;
  refreshTokenExpiredAt: number;
}

export interface TAppHttpApiSecurityControllerRefreshParams {
  /** User refresh token */
  refresh_token: string;
}

export interface TAppHttpApiSecurityControllerRefreshData {
  /** @format email */
  token: string;
  refreshToken: string;
  refreshTokenExpiredAt: number;
}

export type TAppHttpApiV10ControllerAccountReadData = TUser;

export interface TAppHttpApiV10ControllerAccountUpdatePayload {
  login?: string;
  password?: string;
  country?: string;
  language?: string;
  timeZone?: string;
}

export type TAppHttpApiV10ControllerAccountUpdateData = TUser;

export type TAppHttpApiV10ControllerAccountDeleteData = any;

export interface TAppHttpApiV10ControllerAccountSignUpPayload {
  login?: string;
  password?: string;
}

export type TAppHttpApiV10ControllerAccountSignUpData = TUser;

export interface TAppHttpApiV10ControllerAccountValidatePayload {
  login?: string;
}

export type TAppHttpApiV10ControllerAccountValidateData = TUser;

export type TAppHttpApiV10ControllerAccountCloudResetData = any;

export interface TAppHttpApiV10ControllerAccountCloudSyncPayload {
  /** The database dump to upload. */
  file: File;
  /** Time zone for user account. */
  timeZone: string;
}

export type TAppHttpApiV10ControllerAccountCloudSyncData = any;

export interface TAppHttpApiV10ControllerAccountDevicesReadParams {
  /**
   * Page number
   * @default 1
   */
  page?: number;
  /**
   * Page size
   * @default 20
   */
  limit?: number;
}

export interface TAppHttpApiV10ControllerAccountDevicesReadData {
  items: TDevice[];
  limit: number;
  page: number;
  pages: number;
  total: number;
}

export interface TAppHttpApiV10ControllerAccountDevicesAttachPayload {
  deviceId: string;
  platform: TPlatform;
}

export type TAppHttpApiV10ControllerAccountDevicesAttachData = TDevice;

export interface TAppHttpApiV10ControllerAnalyticsAmountsReadParams {
  /** Currency */
  currency?: TCurrency;
  /**
   * Precision
   * @default 2
   */
  precision?: number;
}

export interface TAppHttpApiV10ControllerAnalyticsAmountsReadData {
  currency: TCurrency;
  accounts?: Record<string, TAccount>;
  [key: string]: any;
}

export interface TAppHttpApiV10ControllerExchangeRatesReadParams {
  /** Base currency */
  currency: string;
  /**
   * Precision
   * @default 2
   */
  precision?: number;
  /**
   * @format yyyy-MM-dd
   * @example "2021-06-03"
   */
  date?: string;
}

export type TAppHttpApiV10ControllerExchangeRatesReadData = TRate[];

export interface TAppHttpApiV10ControllerHealthCheckParams {
  /** App platform */
  platform: string;
  /** App version */
  version: string;
}

export interface TAppHttpApiV10ControllerHealthCheckData {
  apiHost: string;
  imageHost: string;
  features: TFeature[];
}

export interface TAppHttpApiSecurityControllerSessionCreateData {
  /** @format uuid */
  uuid: string;
}

export interface TAppHttpApiSecurityControllerSessionReadData {
  /** @format email */
  token: string;
  refreshToken: string;
  refreshTokenExpiredAt: number;
}

export type TAppHttpApiSecurityControllerSessionAttachData = any;

export interface TAppHttpApiV10ControllerWalletAccountsReadParams {
  /** Account type */
  type?: TAccountType;
  /**
   * Page number
   * @default 1
   */
  page?: number;
  /**
   * Page size
   * @default 20
   */
  limit?: number;
}

export interface TAppHttpApiV10ControllerWalletAccountsReadData {
  items: TAccount[];
  limit: number;
  page: number;
  pages: number;
  total: number;
}

export type TAppHttpApiV10ControllerWalletAccountsCreateData = TAccount;

export type TAppHttpApiV10ControllerWalletAccountReadData = TAccount;

export type TAppHttpApiV10ControllerWalletAccountUpdatePayload = object;

export type TAppHttpApiV10ControllerWalletAccountUpdateData = TAccount;

export type TAppHttpApiV10ControllerWalletAccountDeletePayload = object;

export type TAppHttpApiV10ControllerWalletAccountDeleteData = any;

export interface TAppHttpApiV10ControllerWalletAccountTransactionsReadParams {
  /**
   * Page number
   * @default 1
   */
  page?: number;
  /**
   * Page size
   * @default 20
   */
  limit?: number;
  /**
   * Account Uuid
   * @format uuid
   */
  account: string;
}

export interface TAppHttpApiV10ControllerWalletAccountTransactionsReadData {
  items: TTransaction[];
  limit: number;
  page: number;
  pages: number;
  total: number;
}

export interface TAppHttpApiV10ControllerWalletSummaryDashboardReadParams {
  currency?: TCurrency;
  /**
   * Start of period
   * @format yyyy-MM-dd
   * @example "2020-09-03"
   */
  start?: string;
  /**
   * End of period
   * @format yyyy-MM-dd
   * @example "2020-09-03"
   */
  end?: string;
  /**
   * Precision
   * @default 2
   */
  precision?: number;
}

export interface TAppHttpApiV10ControllerWalletSummaryDashboardReadData {
  currency: TCurrency;
  income: number;
  outcome: number;
  balance: number;
  debts: number;
}

export interface TAppHttpApiV10ControllerWalletSummaryTotalsReadParams {
  /**
   * Start of period
   * @format yyyy-MM-dd
   * @example "2020-09-03"
   */
  start?: string;
  /**
   * End of period
   * @format yyyy-MM-dd
   * @example "2020-09-03"
   */
  end?: string;
}

export type TAppHttpApiV10ControllerWalletSummaryTotalsReadData = {
  /** @format uuid */
  uuid: string;
  type: TAccountType;
  amount: number;
}[];

export interface TAppHttpApiV10ControllerWalletTransactionsReadParams {
  /**
   * Start of period
   * @format yyyy-MM-dd
   * @example "2020-09-03"
   */
  start?: string;
  /**
   * End of period
   * @format yyyy-MM-dd
   * @example "2020-09-03"
   */
  end?: string;
  /**
   * Page number
   * @default 1
   */
  page?: number;
  /**
   * Page size
   * @default 20
   */
  limit?: number;
}

export interface TAppHttpApiV10ControllerWalletTransactionsReadData {
  items: TTransaction[];
  limit: number;
  page: number;
  pages: number;
  total: number;
}

export interface TAppHttpApiV10ControllerWalletTransactionsCreatePayload {
  /** @format uuid */
  leftUuid: string;
  /** @format uuid */
  rightUuid: string;
  leftAmount: number;
  rightAmount: number;
  rate: number;
  /**
   * @format yyyy-MM-dd HH:mm
   * @example "2020-04-05 17:00"
   */
  processedAt?: string;
  description?: string;
}

export interface TAppHttpApiV10ControllerWalletTransactionsCreateData {
  transaction: TTransaction;
  accounts: TAccount[];
}

export type TAppHttpApiV10ControllerWalletTransactionUpdatePayload = object;

export interface TAppHttpApiV10ControllerWalletTransactionUpdateData {
  transaction: TTransaction;
  accounts: TAccount[];
}

export type TAppHttpApiV10ControllerWalletTransactionDeletePayload = object;

export interface TAppHttpApiV10ControllerWalletTransactionDeleteData {
  accounts: TAccount[];
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "https://api.yoney.ru/api" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Yoney API
 * @version 1.0
 * @baseUrl https://api.yoney.ru/api
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  login = {
    /**
     * No description
     *
     * @tags Security
     * @name AppHttpApiSecurityControllerLogin
     * @summary Get access token
     * @request POST:/login
     * @secure
     */
    appHttpApiSecurityControllerLogin: (data: TAppHttpApiSecurityControllerLoginPayload, params: RequestParams = {}) =>
      this.request<TAppHttpApiSecurityControllerLoginData, any>({
        path: `/login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  token = {
    /**
     * No description
     *
     * @tags Security
     * @name AppHttpApiSecurityControllerRefresh
     * @summary Refresh access token
     * @request POST:/token/refresh
     * @secure
     */
    appHttpApiSecurityControllerRefresh: (
      query: TAppHttpApiSecurityControllerRefreshParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiSecurityControllerRefreshData, any>({
        path: `/token/refresh`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),
  };
  v10 = {
    /**
     * No description
     *
     * @tags Profile
     * @name AppHttpApiV10ControllerAccountRead
     * @summary Read profile
     * @request GET:/1.0/account
     * @secure
     */
    appHttpApiV10ControllerAccountRead: (params: RequestParams = {}) =>
      this.request<TAppHttpApiV10ControllerAccountReadData, any>({
        path: `/1.0/account`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile
     * @name AppHttpApiV10ControllerAccountUpdate
     * @summary Update profile
     * @request PATCH:/1.0/account
     * @secure
     */
    appHttpApiV10ControllerAccountUpdate: (
      data: TAppHttpApiV10ControllerAccountUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerAccountUpdateData, any>({
        path: `/1.0/account`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile
     * @name AppHttpApiV10ControllerAccountDelete
     * @summary Delete profile
     * @request DELETE:/1.0/account
     * @secure
     */
    appHttpApiV10ControllerAccountDelete: (params: RequestParams = {}) =>
      this.request<TAppHttpApiV10ControllerAccountDeleteData, any>({
        path: `/1.0/account`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Регистрация
     * @name AppHttpApiV10ControllerAccountSignUp
     * @summary Создание нового пользователя
     * @request POST:/1.0/account/signup
     * @secure
     */
    appHttpApiV10ControllerAccountSignUp: (
      data: TAppHttpApiV10ControllerAccountSignUpPayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerAccountSignUpData, any>({
        path: `/1.0/account/signup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Регистрация
     * @name AppHttpApiV10ControllerAccountValidate
     * @summary Проверка данных нового пользователя
     * @request POST:/1.0/account/validate
     * @secure
     */
    appHttpApiV10ControllerAccountValidate: (
      data: TAppHttpApiV10ControllerAccountValidatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerAccountValidateData, void>({
        path: `/1.0/account/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cloud
     * @name AppHttpApiV10ControllerAccountCloudReset
     * @summary Upload and sync database with cloud
     * @request POST:/1.0/account/cloud/reset
     * @secure
     */
    appHttpApiV10ControllerAccountCloudReset: (params: RequestParams = {}) =>
      this.request<TAppHttpApiV10ControllerAccountCloudResetData, any>({
        path: `/1.0/account/cloud/reset`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cloud
     * @name AppHttpApiV10ControllerAccountCloudSync
     * @summary Upload and sync database with cloud
     * @request POST:/1.0/account/cloud/sync
     * @secure
     */
    appHttpApiV10ControllerAccountCloudSync: (
      data?: TAppHttpApiV10ControllerAccountCloudSyncPayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerAccountCloudSyncData, any>({
        path: `/1.0/account/cloud/sync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AppHttpApiV10ControllerAccountDevicesRead
     * @summary Get devices list
     * @request GET:/1.0/account/devices
     * @secure
     */
    appHttpApiV10ControllerAccountDevicesRead: (
      query: TAppHttpApiV10ControllerAccountDevicesReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerAccountDevicesReadData, any>({
        path: `/1.0/account/devices`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AppHttpApiV10ControllerAccountDevicesAttach
     * @summary Attach device
     * @request POST:/1.0/account/devices
     * @secure
     */
    appHttpApiV10ControllerAccountDevicesAttach: (
      data: TAppHttpApiV10ControllerAccountDevicesAttachPayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerAccountDevicesAttachData, any>({
        path: `/1.0/account/devices`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name AppHttpApiV10ControllerAnalyticsAmountsRead
     * @summary Get amounts by months and years
     * @request GET:/1.0/analytics
     * @secure
     */
    appHttpApiV10ControllerAnalyticsAmountsRead: (
      query: TAppHttpApiV10ControllerAnalyticsAmountsReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerAnalyticsAmountsReadData, any>({
        path: `/1.0/analytics`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exchange
     * @name AppHttpApiV10ControllerExchangeRatesRead
     * @summary Get latest rates
     * @request GET:/1.0/exchange/rates
     * @secure
     */
    appHttpApiV10ControllerExchangeRatesRead: (
      query: TAppHttpApiV10ControllerExchangeRatesReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerExchangeRatesReadData, any>({
        path: `/1.0/exchange/rates`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags App
     * @name AppHttpApiV10ControllerHealthCheck
     * @summary Health check
     * @request GET:/1.0/health-check
     * @secure
     */
    appHttpApiV10ControllerHealthCheck: (
      query: TAppHttpApiV10ControllerHealthCheckParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerHealthCheckData, any>({
        path: `/1.0/health-check`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AppHttpApiV10ControllerWalletAccountsRead
     * @summary Get accounts list
     * @request GET:/1.0/wallet/accounts
     * @secure
     */
    appHttpApiV10ControllerWalletAccountsRead: (
      query: TAppHttpApiV10ControllerWalletAccountsReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletAccountsReadData, any>({
        path: `/1.0/wallet/accounts`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AppHttpApiV10ControllerWalletAccountsCreate
     * @summary Add account
     * @request POST:/1.0/wallet/accounts
     * @secure
     */
    appHttpApiV10ControllerWalletAccountsCreate: (data: TAccount, params: RequestParams = {}) =>
      this.request<TAppHttpApiV10ControllerWalletAccountsCreateData, any>({
        path: `/1.0/wallet/accounts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AppHttpApiV10ControllerWalletAccountRead
     * @summary Read account
     * @request GET:/1.0/wallet/accounts/{account}
     * @secure
     */
    appHttpApiV10ControllerWalletAccountRead: (account: string, params: RequestParams = {}) =>
      this.request<TAppHttpApiV10ControllerWalletAccountReadData, any>({
        path: `/1.0/wallet/accounts/${account}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AppHttpApiV10ControllerWalletAccountUpdate
     * @summary Update account
     * @request PATCH:/1.0/wallet/accounts/{account}
     * @secure
     */
    appHttpApiV10ControllerWalletAccountUpdate: (
      account: string,
      data: TAppHttpApiV10ControllerWalletAccountUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletAccountUpdateData, any>({
        path: `/1.0/wallet/accounts/${account}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AppHttpApiV10ControllerWalletAccountDelete
     * @summary Delete account
     * @request DELETE:/1.0/wallet/accounts/{account}
     * @secure
     */
    appHttpApiV10ControllerWalletAccountDelete: (
      account: string,
      data: TAppHttpApiV10ControllerWalletAccountDeletePayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletAccountDeleteData, any>({
        path: `/1.0/wallet/accounts/${account}`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name AppHttpApiV10ControllerWalletAccountTransactionsRead
     * @summary Get account transactions list
     * @request GET:/1.0/wallet/accounts/{account}/transactions
     * @secure
     */
    appHttpApiV10ControllerWalletAccountTransactionsRead: (
      { account, ...query }: TAppHttpApiV10ControllerWalletAccountTransactionsReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletAccountTransactionsReadData, any>({
        path: `/1.0/wallet/accounts/${account}/transactions`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Summary
     * @name AppHttpApiV10ControllerWalletSummaryDashboardRead
     * @summary Get dashboard
     * @request GET:/1.0/wallet/summary/dashboard
     * @secure
     */
    appHttpApiV10ControllerWalletSummaryDashboardRead: (
      query: TAppHttpApiV10ControllerWalletSummaryDashboardReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletSummaryDashboardReadData, any>({
        path: `/1.0/wallet/summary/dashboard`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Summary
     * @name AppHttpApiV10ControllerWalletSummaryTotalsRead
     * @summary Get totals
     * @request GET:/1.0/wallet/summary/totals
     * @secure
     */
    appHttpApiV10ControllerWalletSummaryTotalsRead: (
      query: TAppHttpApiV10ControllerWalletSummaryTotalsReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletSummaryTotalsReadData, any>({
        path: `/1.0/wallet/summary/totals`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name AppHttpApiV10ControllerWalletTransactionsRead
     * @summary Get transactions list
     * @request GET:/1.0/wallet/transactions
     * @secure
     */
    appHttpApiV10ControllerWalletTransactionsRead: (
      query: TAppHttpApiV10ControllerWalletTransactionsReadParams,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletTransactionsReadData, any>({
        path: `/1.0/wallet/transactions`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name AppHttpApiV10ControllerWalletTransactionsCreate
     * @summary Add transaction
     * @request POST:/1.0/wallet/transactions
     * @secure
     */
    appHttpApiV10ControllerWalletTransactionsCreate: (
      data: TAppHttpApiV10ControllerWalletTransactionsCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletTransactionsCreateData, any>({
        path: `/1.0/wallet/transactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name AppHttpApiV10ControllerWalletTransactionUpdate
     * @summary Update transaction
     * @request PATCH:/1.0/wallet/transactions/{transaction}
     * @secure
     */
    appHttpApiV10ControllerWalletTransactionUpdate: (
      transaction: string,
      data: TAppHttpApiV10ControllerWalletTransactionUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletTransactionUpdateData, any>({
        path: `/1.0/wallet/transactions/${transaction}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name AppHttpApiV10ControllerWalletTransactionDelete
     * @summary Delete transaction
     * @request DELETE:/1.0/wallet/transactions/{transaction}
     * @secure
     */
    appHttpApiV10ControllerWalletTransactionDelete: (
      transaction: string,
      data: TAppHttpApiV10ControllerWalletTransactionDeletePayload,
      params: RequestParams = {},
    ) =>
      this.request<TAppHttpApiV10ControllerWalletTransactionDeleteData, any>({
        path: `/1.0/wallet/transactions/${transaction}`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  session = {
    /**
     * No description
     *
     * @tags Session
     * @name AppHttpApiSecurityControllerSessionCreate
     * @summary Create temporary session
     * @request POST:/session
     * @secure
     */
    appHttpApiSecurityControllerSessionCreate: (params: RequestParams = {}) =>
      this.request<TAppHttpApiSecurityControllerSessionCreateData, any>({
        path: `/session`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name AppHttpApiSecurityControllerSessionRead
     * @summary Read temporary session
     * @request GET:/session/{uuid}
     * @secure
     */
    appHttpApiSecurityControllerSessionRead: (uuid: string, params: RequestParams = {}) =>
      this.request<TAppHttpApiSecurityControllerSessionReadData, void>({
        path: `/session/${uuid}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name AppHttpApiSecurityControllerSessionAttach
     * @summary Attach user to temporary session
     * @request PATCH:/session/{uuid}
     * @secure
     */
    appHttpApiSecurityControllerSessionAttach: (uuid: string, params: RequestParams = {}) =>
      this.request<TAppHttpApiSecurityControllerSessionAttachData, void>({
        path: `/session/${uuid}`,
        method: "PATCH",
        secure: true,
        ...params,
      }),
  };
}
